import { render, staticRenderFns } from "./BordereauLivraisonList.vue?vue&type=template&id=2a6d18f1&scoped=true"
import script from "./BordereauLivraisonList.vue?vue&type=script&lang=js"
export * from "./BordereauLivraisonList.vue?vue&type=script&lang=js"
import style0 from "./BordereauLivraisonList.vue?vue&type=style&index=0&id=2a6d18f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d18f1",
  null
  
)

export default component.exports